import CloseRounded from '@mui/icons-material/CloseRounded';
import { IconButton } from '@mui/material';
import { Post, PostWithMatchPostId } from 'lib/types';
import { useEffect, useState } from 'react';
import { SimpleCard } from 'components/SimpleCard';

interface Props {
  posts: (Post|PostWithMatchPostId)[];
  onSelect: (post: Post|PostWithMatchPostId) => void;
}

export const SimilarPosts = ({
  posts, onSelect,
}: Props) => {
  const header = 'We found some similar posts!';
  const [isOpen, setOpen] = useState(posts.length > 0);

  const renderPosts = () => posts.map((p) => (
    <SimpleCard post={p} key={p.id} onChange={() => onSelect(p)} />
  ));

  useEffect(() => {
    setOpen(posts.length > 0);
  }, [posts]);

  if (!isOpen) return null;

  return (
    <div className="relative mt-2 border rounded-lg p-2 bg-teal max-w-sm text-center">
      <h1 className="font-bold px-6 pt-2">{header}</h1>
      <h2 className="pb-2 text-sm">Check the box to add them</h2>
      <div className="absolute top-0 right-0">
        <IconButton
          color="primary"
          size="large"
          aria-label="close similar posts"
          onClick={() => setOpen(false)}
        >
          <CloseRounded fontSize="small" />
        </IconButton>
      </div>
      <div className="overflow-x-scroll">
        <div className="flex items-stretch justify-center gap-4 min-w-fit">
          {renderPosts()}
        </div>
      </div>
    </div>
  );
};
